<div>
  <div class="flex items-center py-1">
    <!-- Ícone de expandir/colapsar -->
    <button
      *ngIf="node.children.length > 0"
      (click)="onToggleExpand()"
      class="mr-2 w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 focus:outline-none">
      <i [class]="node.expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="text-xs"></i>
    </button>
    <span *ngIf="node.children.length === 0" class="mr-2 w-6"></span>

    <!-- Checkbox -->
    <label class="flex items-center cursor-pointer flex-1">
      <input
        type="checkbox"
        [checked]="node.selected"
        [indeterminate]="node.indeterminate"
        (change)="onToggleSelection()"
        class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
      <span class="ml-2 text-sm text-gray-700">
        <strong>{{ node.permission.name }}</strong>
        <span *ngIf="node.permission.description" class="text-gray-500 text-xs ml-2">
          - {{ node.permission.description }}
        </span>
        <span class="text-gray-400 text-xs ml-2">({{ node.permission.key }})</span>
      </span>
    </label>
  </div>

  <!-- Filhos recursivos -->
  <ul *ngIf="node.expanded && node.children.length > 0" class="ml-8 mt-1 space-y-1">
    <li *ngFor="let childNode of node.children" class="permission-node">
      <app-permission-node
        [node]="childNode"
        (toggleExpand)="toggleExpand.emit($event)"
        (toggleSelection)="toggleSelection.emit($event)">
      </app-permission-node>
    </li>
  </ul>
</div>
